import { getDefaultExportFromCjs as s } from "./index.es69.js";
import { _ } from "./index.es94.js";
import { _ as i } from "./index.es95.js";
import { _ as l } from "./index.es96.js";
import { _ as n } from "./index.es97.js";
import { _ as f } from "./index.es98.js";
import { _ as u } from "./index.es99.js";
import { _ as p } from "./index.es100.js";
import { _ as c } from "./index.es101.js";
var C = _, L = i, O = l, v = n, g = f, y = u, A = p, E = c, F = 1, b = 2, D = 4, G = A(function(t, o) {
  var r = {};
  if (t == null)
    return r;
  var a = !1;
  o = C(o, function(e) {
    return e = v(e, t), a || (a = e.length > 1), e;
  }), g(t, E(t), r), a && (r = L(r, F | b | D, y));
  for (var m = o.length; m--; )
    O(r, o[m]);
  return r;
}), M = G;
const w = /* @__PURE__ */ s(M);
export {
  w as default
};
//# sourceMappingURL=index.es45.js.map
